// extracted by mini-css-extract-plugin
export default {"group__wrapperSelect":"ChangeRole_group__wrapperSelect__5Fws-","group__arrow":"ChangeRole_group__arrow__w3bh4","group__select":"ChangeRole_group__select__snaZU"};